<template>
  <div class="loading loading--lg">
    <div v-for="index in 12" :key="index" />
  </div>
</template>
